<template>
  <article class="quiz-body">
    <div class="quiz-title">
      <span class="material-icons-outlined color-quiz-icon">info</span>
      <span class="title">{{ localizedName }}</span>
    </div>
    <div class="p-2">
      <p class="text">{{ localizedDescription }}</p>
      <RouterLink :to="`/quiz-profiway/${item?.id}`" class="color-quiz">
        {{ t('surveyStart') }}
      </RouterLink>
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  item: {
    type: Object,
    default: () => ({})
  }
});

const { t, locale } = useI18n();

const normalizedLang = computed(() => (locale.value === 'kz' ? 'kk' : locale.value || 'ru'));

const localizedName = computed(
  () => props.item?.name?.[normalizedLang.value] || props.item?.name_current || ''
);

const localizedDescription = computed(
  () => props.item?.description?.[normalizedLang.value] || props.item?.description_current || ''
);
</script>

<style scoped>
.quiz-title {
  display: flex;
  background: #1890ff;
  padding: 8px;
  border-radius: 4px 4px 0 0;
  color: #fff;
  min-height: 44px;
  align-items: center;
}

.quiz-body {
  border: 1px solid #e0e0e0;
  background: #e6f7ff;
  border-color: rgba(145, 213, 255, 0.6);
  border-radius: 4px;
}

.title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-left: 8px;
}

.text {
  font-size: 14px;
  line-height: 22px;
  text-align: justify;
  color: #000;
  margin-bottom: 4px;
}

.color-quiz {
  color: #1890ff;
}
</style>
